import momentTZ from "moment-timezone";
import moment from "moment";

import "moment/locale/fr";
import "moment/locale/nl";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/en-gb";

export const setLocale = (locale, timezone) => {
  moment.locale(locale); // apply it to moment

  momentTZ.defineLocale(locale, moment.localeData()._config); // copy locale to moment-timezone
  momentTZ.locale(locale); // apply it to moment-timezone

  momentTZ.tz.setDefault(timezone); // set timezone
};

export default momentTZ;
